const getDefaultApiBaseUrl = () => {
    if (typeof window !== 'undefined') {
        const { protocol, hostname } = window.location;

        if (hostname === 'localhost' || hostname === '127.0.0.1') {
            return `${protocol}//${hostname}:5001/backend/api`;
        }
    }

    return 'https://redgotrips.com/backend/api';
};

const rawApiBaseUrl =
    process.env.REACT_APP_API_BASE_URL || getDefaultApiBaseUrl();

export const API_BASE_URL = rawApiBaseUrl.replace(/\/$/, '');

const getDefaultUploadsBaseUrl = () => {
    try {
        const apiUrl = new URL(API_BASE_URL);
        return `${apiUrl.origin}/backend/uploads`;
    } catch (error) {
        if (typeof window !== 'undefined') {
            return `${window.location.protocol}//${window.location.host}/backend/uploads`;
        }
    }

    return 'https://redgotrips.com/backend/uploads';
};

const rawUploadsBaseUrl =
    process.env.REACT_APP_UPLOADS_BASE_URL || getDefaultUploadsBaseUrl();

export const UPLOADS_BASE_URL = rawUploadsBaseUrl.replace(/\/$/, '');
export const CAMPING_UPLOADS_BASE_URL = `${UPLOADS_BASE_URL}/camping`;

export const buildApiUrl = (path = '') => {
    if (!path) {
        return API_BASE_URL;
    }

    return `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};

export const toUploadUrl = (imagePath, options = {}) => {
    const { camping = false, fallback = '' } = options;

    if (!imagePath) {
        return fallback;
    }

    if (imagePath.startsWith('data:')) {
        return imagePath;
    }

    if (imagePath.startsWith('http')) {
        try {
            const imageUrl = new URL(imagePath);

            if (/^\/uploads\//i.test(imageUrl.pathname)) {
                imageUrl.pathname = imageUrl.pathname.replace(/^\/uploads\//i, '/backend/uploads/');
                return imageUrl.toString();
            }

            return imagePath;
        } catch (error) {
            return imagePath;
        }
    }

    const normalizedPath = imagePath
        .replace(/^\/+/, '')
        .replace(/^backend\/uploads\/?/i, '')
        .replace(/^uploads\/?/i, '');
    const baseUrl = camping ? CAMPING_UPLOADS_BASE_URL : UPLOADS_BASE_URL;

    return `${baseUrl}/${normalizedPath}`;
};
